import { createContext, useContext, useMemo } from "react";
import { trpc } from "./trpc";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const utils = trpc.useUtils();
  const me = trpc.auth.me.useQuery();
  const loginM = trpc.auth.login.useMutation();
  const signupM = trpc.auth.signup.useMutation();
  const logoutM = trpc.auth.logout.useMutation();

  const value = useMemo(
    () => ({
      user: me.data ?? null,
      isLoading: me.isLoading,
      login: async (email, password) => {
        await loginM.mutateAsync({ email, password });
        await Promise.all([utils.auth.me.invalidate(), utils.auth.adminStatus.invalidate()]);
      },
      signup: async (email, password, name) => {
        await signupM.mutateAsync({ email, password, name });
        await Promise.all([utils.auth.me.invalidate(), utils.auth.adminStatus.invalidate()]);
      },
      logout: async () => {
        await logoutM.mutateAsync();
        await Promise.all([utils.auth.me.invalidate(), utils.auth.adminStatus.invalidate()]);
      },
    }),
    [me.data, me.isLoading, loginM, signupM, logoutM, utils],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
  return ctx;
}
